import React from 'react';
import { Link } from 'react-router-dom';

function Stats() {
  return (
    <div className="container py-4 py-md-5">
      <div className="row align-items-center">

        {/* Left Content */}
        <div className="col-12 col-md-6 mb-4 mb-md-0 text-center text-md-start">
          <h1 className="fs-2 mb-4">Trust With Confidence</h1>

          <h3 className="fs-5">Customer-first always</h3>
          <p className="text-muted">
            That's why 1.3M+ customers trust us
          </p>

          <h3 className="fs-5">No spam or gimmicks</h3>
          <p className="text-muted">
            No gimmicks, spam, "gamification", or annoying push notifications.
            High quality apps that you use at your pace, the way you like.
          </p>

          <h3 className="fs-5">The Zerodha universe</h3>
          <p className="text-muted">
            Not just an app, but a whole ecosystem. Our investments in 30+
            fintech startups offer you tailored services specific to your needs.
          </p>

          <h3 className="fs-5">Do better with money</h3>
          <p className="text-muted">
            With initiatives like Nudge and Kill Switch, we don't just
            facilitate transactions, but actively help you do better with
            your money.
          </p>
        </div>

        {/* Right Image + Links */}
        <div className="col-12 col-md-6 text-center">
          <img
            src="media/ecosystem.png"
            alt="Stats"
            className="img-fluid mb-3"
            style={{ maxWidth: "90%" }}
          />

          <div>
            <Link
              to="/products"
              className="d-block d-md-inline mx-md-3 mb-2"
              style={{ textDecoration: "none" }}
            >
              Explore our Products
            </Link>

            <Link
              to="/kite-demo"
              className="d-block d-md-inline mx-md-3"
              style={{ textDecoration: "none" }}
            >
              Try Kite Demo
            </Link>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Stats;